import PrivacyContent from '../components/PrivacyContent'

export default function PrivacyPage() {


return <div>
	<PrivacyContent/>
</div>
}
